const Spacer = () => (
  <div
    sx={{
      flex: 1,
    }}
  />
)

export default Spacer
